export const NoticeRecordCategory = Object.freeze({
  NEW_FEATURE: 'NEW_FEATURE', //功能上线
  OPTIMIZATION: 'OPTIMIZATION', //功能优化
  NEW_ITERATION: 'NEW_ITERATION', //版本迭代
  APP_CUSTOM_CRASH_ALARM: 'APP_CUSTOM_CRASH_ALARM', //自定义崩溃
  APP_CUSTOM_ANR_ALARM: 'APP_CUSTOM_ANR_ALARM', //自定义ANR
  APP_CUSTOM_ERROR_ALARM: 'APP_CUSTOM_ERROR_ALARM', //自定义错误
  APP_CUSTOM_HANG_ALARM: 'APP_CUSTOM_HANG_ALARM', //自定义卡死
  APP_CUSTOM_OOM_ALARM: 'APP_CUSTOM_OOM_ALARM', //自定义OOM
  APP_CUSTOM_MIXED_ALARM: 'APP_CUSTOM_MIXED_ALARM', //自定义多类型混合
  APP_CUSTOM_ALARM_PUSH_FAILED: 'APP_CUSTOM_ALARM_PUSH_FAILED', //自定义告警-告警推送失败
  APP_PRECONFIGURED_CRASH_ALARM: 'APP_PRECONFIGURED_CRASH_ALARM', //系统崩溃
  APP_PRECONFIGURED_ERROR_ALARM: 'APP_PRECONFIGURED_ERROR_ALARM', //系统错误
});
